import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BrandDiscount, defaultBrandDiscount } from "../../models/responses/brandDiscount";
import { interpretAsDecimal } from "../services/calculationsHelperService";

export interface BrandDiscountState {
    brandDiscountList: BrandDiscount[];
    brandDiscount: BrandDiscount;
    isWaitingBrandDiscountPostResponse: boolean;
    isWaitingBrandDiscountPutResponse: boolean;
    totalQueryBrandDiscount: number;
    isWaitingBrandDiscountGetResponse: boolean;
}

const initialState: BrandDiscountState = {
    brandDiscountList: [],
    brandDiscount: { ...defaultBrandDiscount },
    isWaitingBrandDiscountPostResponse: false,
    isWaitingBrandDiscountPutResponse: false,
    isWaitingBrandDiscountGetResponse: false,
    totalQueryBrandDiscount: 0,
};

const calculateDecimals = (brandDiscount: BrandDiscount): BrandDiscount => {
    return {
        ...brandDiscount,
        workshopSalesDiscount: interpretAsDecimal(parseFloat(brandDiscount.workshopSalesDiscount)).toFixed(2).toString(),
        storeDiscount: interpretAsDecimal(parseFloat(brandDiscount.storeDiscount)).toFixed(2).toString(),
    }
}

const brandDiscountSlice = createSlice({
    name: 'brandDiscount',
    initialState,
    reducers: {
        setBrandDiscountList: (state, action: PayloadAction<{
            brandDiscounts: BrandDiscount[];
        }>) => {
            state.brandDiscountList = action.payload.brandDiscounts.map(brandDiscount => ({
                ...calculateDecimals(brandDiscount)
            })
            );
            return state;
        },
        setBrandDiscount: (state, action: PayloadAction<{
            brandDiscount: BrandDiscount;
        }>) => {
            state.brandDiscount = { ...calculateDecimals(action.payload.brandDiscount) };            
            return state;
        },
        setIsWaitingBrandDiscountPostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingBrandDiscountPostResponse = action.payload;
        },
        setIsWaitingBrandDiscountPutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingBrandDiscountPutResponse = action.payload;
        },
        setIsWaitingBrandDiscountGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingBrandDiscountGetResponse = action.payload;
        }
    },
});

export const {
    setBrandDiscountList,
    setBrandDiscount,
    setIsWaitingBrandDiscountPostResponse,
    setIsWaitingBrandDiscountPutResponse,
    setIsWaitingBrandDiscountGetResponse,
} = brandDiscountSlice.actions;

export default brandDiscountSlice.reducer;